import { ModuleAction } from "./Action/ModuleAction.js";
import { ModuleFAQ } from "./FAQ/ModuleFAQ.js";
import { ModuleInfo } from "./Info/ModuleInfo.js";
import { ModuleLayout } from "./Layout/ModuleLayout.js";
import { ModuleLogoCloud } from "./LogoCloud/ModuleLogoCloud.js";
import { ModuleSellingPoints } from "./SellingPoints/ModuleSellingPoints.js";
import { ModuleStats } from "./Stats/ModuleStats.js";
import { ModuleSubscribe } from "./Subscribe/ModuleSubscribe.js";
import { ModuleTestimonials } from "./Testimonials/ModuleTestimonials.js";
const Module = {
    Layout: ModuleLayout,
    Action: ModuleAction,
    Subscribe: ModuleSubscribe,
    Stats: ModuleStats,
    FAQ: ModuleFAQ,
    Info: ModuleInfo,
    SellingPoints: ModuleSellingPoints,
    LogoCloud: ModuleLogoCloud,
    Testimonials: ModuleTestimonials
};
export { Module };
